import { useContext, useMemo } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const useAdditionalSearchParams = ({
  askForSponsored = false,
  hasSponsoredSorts = true,
  deliveryZip = null,
  showProducts = false,
  skipSpellCheck = false
} = {}) => {
  const ctx = useContext(ExperienceContext);
  const { cookie, customer } = ctx;

  const additionalSearchParams = useMemo(() => {
    const params = {};

    if (askForSponsored && hasSponsoredSorts) {
      params.sponsored = true;
    }

    if (cookie?.adobeCookie?.MCMID) {
      params.mcvisId = cookie.adobeCookie.MCMID;
    }

    if (showProducts) {
      params.plp = true;
    }

    if (skipSpellCheck) {
      params.skipSpellCheck = skipSpellCheck;
    }

    if (deliveryZip) {
      params.deliveryZip = deliveryZip;
    }

    if (customer?.svocId) {
      params.svocID = customer.svocId;
    }

    if (typeof window !== 'undefined') {
      const THDCustomer = window.THDCustomer?.default || {};
      if (Object.keys(THDCustomer).length !== 0 && THDCustomer.svocID) {
        params.svocID = THDCustomer.svocID;
      }
    }

    return params;
  }, [
    askForSponsored,
    hasSponsoredSorts,
    deliveryZip,
    showProducts,
    skipSpellCheck,
    cookie?.adobeCookie?.MCMID,
    customer?.svocId
  ]);

  return additionalSearchParams;
};

export default useAdditionalSearchParams;